var map = {
	"./Background_Removal.webm": "322d",
	"./Face_Restoration.webm": "8d65",
	"./Face_to_Sticker.webm": "56db",
	"./Image_De-Oldify.webm": "3792",
	"./Image_Upscale.webm": "ad3d",
	"./Inpainting_Removal.webm": "79f1",
	"./Photo_to_Anime.webm": "44d9",
	"./Prompt_Generation.webm": "f6d5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "009c";